import { render, staticRenderFns } from "./SlideBanks.vue?vue&type=template&id=5f8cb13c&scoped=true&"
import script from "./SlideBanks.vue?vue&type=script&lang=ts&"
export * from "./SlideBanks.vue?vue&type=script&lang=ts&"
import style0 from "./SlideBanks.vue?vue&type=style&index=0&id=5f8cb13c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8cb13c",
  null
  
)

export default component.exports